
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bangladesh",
      function () {
        return require("private-next-pages/bangladesh.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bangladesh"])
      });
    }
  